import { render } from "./UserAndImage.vue?vue&type=template&id=d1748332&scoped=true"
import script from "./UserAndImage.vue?vue&type=script&lang=js"
export * from "./UserAndImage.vue?vue&type=script&lang=js"

import "./UserAndImage.vue?vue&type=style&index=0&id=d1748332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1748332"]])

export default __exports__